<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Certifications</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card-group deck>
        <b-card no-body title="" class="text-center">
          <b-card-body>
            <img src="/img/admin.png" style="width:50%;" class="mb-3">
            <b-card-title>Admin Certification</b-card-title>
            <b-card-text>
              You will learn how to add team members/users, add listings and transactions, communicate with your team and track your expenses.
            </b-card-text>
          </b-card-body>
          <b-card-footer>
            <b-button block variant="danger" @click="startChecklist(adminCert)">Start</b-button>
          </b-card-footer>
        </b-card>

        <b-card no-body class="text-center">
          <b-card-body>
            <img src="/img/team.png" style="width:50%;" class="mb-3">
            <b-card-title>CEO Certification</b-card-title>
            <b-card-text>
              You will learn how to read the reports in ClarityNOW and how to use them to manage your business.
            </b-card-text>
          </b-card-body>
          <b-card-footer>
            <b-button block variant="danger" @click="startChecklist(ceoCert)">Start</b-button>
          </b-card-footer>
        </b-card>

        <b-card no-body class="text-center">
          <b-card-body>
            <img src="/img/plan.png" style="width:50%;" class="mb-3">
            <b-card-title>Business Planning Certification</b-card-title>
            <b-card-text>
              You will learn how to read the reports in ClarityNOW and how to use them to manage your business.
            </b-card-text>
          </b-card-body>
          <b-card-footer>
            <b-button block variant="danger" @click="startChecklist(businessCert)">Start</b-button>
          </b-card-footer>
        </b-card>

        <b-card no-body class="text-center">
          <b-card-body>
            <img src="/img/recruitment.png" style="width:50%;" class="mb-3">
            <b-card-title>Lead Gen Certification</b-card-title>
            <b-card-text>
              You will learn how manage your pipeline and track the activities you are doing to move your clients through that pipeline.
            </b-card-text>
          </b-card-body>
          <b-card-footer>
            <b-button block variant="danger" @click="startChecklist(leadGenCert)">Start</b-button>
          </b-card-footer>
        </b-card>
      </b-card-group>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

export default {
  components: {
    RouteBreadCrumb
  },
  computed: {
    ...mapGetters({
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    adminCert() {
      return this.subscribed ? process.env.VUE_APP_USERPILOT_ADMIN : 'checklist:FseN0apFvY';
    },
    ceoCert() {
      return this.subscribed ? process.env.VUE_APP_USERPILOT_CEO : 'checklist:KZxnHAHtDo';
    },
    businessCert() {
      return this.subscribed ? process.env.VUE_APP_USERPILOT_BP : 'checklist:omufdgAMxa';
    },
    leadGenCert() {
      return this.subscribed ? process.env.VUE_APP_USERPILOT_LG : 'checklist:wPxZoXsZe-';
    }
  },
  methods: {
    startChecklist(id) {
      userpilot.trigger(id);
    }
  }
};
</script>